export const pwaMappings = {
  PWA_INSTALL_TITLE: {
    en: 'Install Orgbrain',
    nb: 'Installer Orgbrain',
  },
  PWA_PROMPT_MESSAGE: {
    en: 'Install the Orgbrain app for faster access and a better experience.',
    nb: 'Installer Orgbrain-appen for raskere tilgang og bedre opplevelse.',
  },
  PWA_IOS_PROMPT_MESSAGE: {
    en: 'Add Orgbrain to your home screen! Tap the share button and select "Add to Home Screen".',
    nb: 'Legg til Orgbrain på startskjermen din! Trykk på del-ikonet og velg "Legg til på startskjerm".',
  },
  PWA_IOS_STEP1: {
    en: '1. Tap share button',
    nb: '1. Trykk på del-ikonet',
  },
  PWA_IOS_STEP2: {
    en: '2. Add to Home Screen',
    nb: '2. Velg "Legg til på Hjem-skjerm"',
  },
  PWA_NOT_NOW: {
    en: 'Not now',
    nb: 'Ikke nå',
  },
  PWA_INSTALL_BUTTON: {
    en: 'Install App',
    nb: 'Installer app',
  },
  PWA_INSTALLING: {
    en: 'Installing...',
    nb: 'Installerer...',
  },
  PWA_CLOSE: {
    en: 'Close',
    nb: 'Lukk',
  },
};

export type PwaMappingKey = keyof typeof pwaMappings;
